'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactColor = require('react-color');

var _common = require('react-color/lib/components/common');

var _pickerPointer = require('./picker-pointer');

var _pickerPointer2 = _interopRequireDefault(_pickerPointer);

var _pickerLocal = require('./picker.local.css');

var _pickerLocal2 = _interopRequireDefault(_pickerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Picker = function (_React$Component) {
  _inherits(Picker, _React$Component);

  function Picker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Picker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Picker.__proto__ || Object.getPrototypeOf(Picker)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (color) {
      _this.props.onChange(color);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Picker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rgb = _props.rgb,
          color = _props.color,
          children = _props.children;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_pickerLocal2.default.picker, _pickerLocal2.default[this.props.theme])
      }, _react2.default.createElement('div', {
        className: _pickerLocal2.default.saturation
      }, _react2.default.createElement(_common.Saturation, _extends({}, this.props, {
        onChange: this.handleChange
      }))), _react2.default.createElement('div', {
        className: _pickerLocal2.default.hue
      }, _react2.default.createElement(_common.Hue, _extends({}, this.props, {
        pointer: _pickerPointer2.default,
        direction: 'horizontal',
        onChange: this.handleChange
      }))), _react2.default.createElement('div', {
        className: _pickerLocal2.default.input
      }, _react2.default.createElement('div', {
        className: _pickerLocal2.default.swatch,
        style: {
          backgroundColor: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)'
        }
      }), _react2.default.createElement(_common.EditableInput, _extends({}, this.props, {
        label: 'hex',
        value: color,
        onChange: this.handleChange
      }))), children);
    }
  }]);

  return Picker;
}(_react2.default.Component);

Picker.defaultProps = {
  theme: 'normal'
};
Picker.propTypes = {
  color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  rgb: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  theme: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};
exports.default = (0, _reactColor.CustomPicker)(Picker);